import {Component, Input} from '@angular/core';
import {Observable} from 'rxjs';
import {DcpLinkModel} from '@app/model/dcp-link-model';

export interface Truste {
  eu: {
    clickListener: (arg: number) => void;
  };
}

declare const truste: Truste;

@Component({
  selector: 'dcp-text-links',
  templateUrl: './text-links.component.html',
})
export class TextLinksComponent {

  truste: Truste = undefined;
  @Input() links: Array<Observable<DcpLinkModel>>;

  constructor() {
    try {
      this.truste = truste;
    } catch (e) {
    }
  }
}
